import { z } from 'zod';
/**
 * High-level buckets for the overall fraud risk assessment of a warranty claim.
 */
export const claimRiskLevel = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
};
export const RiskFactor = {
    emailReuseStore: 'emailReuse-store',
    emailReuseGlobal: 'emailReuse-global',
    orderVerification: 'orderVerification',
    mediaReuse: 'mediaReuse',
    mediaSimilarity: 'mediaSimilarity',
    proofOfPurchaseReuse: 'proofOfPurchaseReuse',
    deviceFanOut: 'deviceFanOut',
    ipFanOut: 'ipFanOut',
    addressFanOut: 'addressFanOut',
    platformRisk: 'platformRisk',
    botDetection: 'botDetection',
    fingerprintSuspectScore: 'fingerprintSuspectScore',
    ipAddress: 'ipAddress',
    isMerchantCreated: 'isMerchantCreated',
};
export const Sentiment = {
    Critical: 'Critical',
    Positive: 'Positive',
    Negative: 'Negative',
    Neutral: 'Neutral',
};
export const claimRiskAssessment = z.object({
    level: z.nativeEnum(claimRiskLevel),
    aggregateScore: z.number(),
    // optional: rows written before provenance was recorded have neither
    calculatedOn: z.string().optional(),
    modelVersion: z.string().optional(),
    facts: z.array(z.object({
        factor: z.nativeEnum(RiskFactor),
        score: z.number(),
        justification: z.string(),
        sentiment: z.nativeEnum(Sentiment),
    })),
});
// creation types for fingerprinting
export const fingerprintCreate = z.object({
    visitorId: z.string().optional(),
    requestId: z.string().optional(),
});
//# sourceMappingURL=claimRiskAssessment.js.map